import { Injectable } from '@angular/core';
import { ParentManagerService } from './parent-manager.service';


type AdobeConnectUser = {
  id: string;
  name: string;
  fullName: string;
  role: string;
};
@Injectable({
  providedIn: 'root'
})

export class AdobeconnectManagerService {
  constructor(private parent: ParentManagerService) { }
  public async myUser(): Promise<AdobeConnectUser> {
    return await this.parent.get('window.cpu.sc.getMyUserDetails()') as AdobeConnectUser;
  }

  public async myUserName(): Promise<string> {
    return (await this.myUser()).name;
  }
  public async myUserFullName(): Promise<string> {
    return (await this.myUser()).fullName;
  }
  public async myUserId(): Promise<string> {
    return (await this.myUser()).id;
  }

  public async myUserRole(): Promise<string> {
    return (await this.myUser()).role;
  }

  public async getUserList(): Promise<AdobeConnectUser[]> {
    return (await this.parent.get('window.cpu.sc._userList')) as AdobeConnectUser[];
  }
  public async getUserCount(): Promise<number> {
    const users = await this.getUserList();
    return users.length;
  }

  public async getParticipants(): Promise<AdobeConnectUser[]> {
    const users = await this.getUserList();
    return users.filter(u => u.role == "viewer");
  }
  public async getParticipantsCount(): Promise<number> {
    const users = await this.getParticipants();
    return users.length;
  }
  public async getPresenters(): Promise<AdobeConnectUser[]> {
    const users = await this.getUserList();
    return users.filter(u => u.role == "presenter");
  }
  public async getPresentersCount(): Promise<number> {
    const users = await this.getParticipants();
    return users.length;
  }
  public async getHosts(): Promise<AdobeConnectUser[]> {
    const users = await this.getUserList();
    return users.filter(u => u.role == "owner");
  }
  public async getHostsCount(): Promise<number> {
    const users = await this.getHosts();
    return users.length;
  }
  public async selectedLayout(): Promise<string> {
    return String(await this.parent.get('window.selectedLayoutName'));
  }
  public dispatchSyncMessage(name: string, value: unknown) {
    this.parent.exec(`window.cpu.dispatchSyncMessage('${name}', ${JSON.stringify(value)}, false, false)`);
  }

  public async isRecording(): Promise<boolean> {
    return await this.parent.get(`window.cpu.sc._isArchive`) as boolean;
  }
  public async getRecordingPlayState(): Promise<boolean> {
    return await this.parent.get(`window.cpu.sc._playState`) as boolean;
  }
  public async isAddin(): Promise<boolean> {
    return await this.parent.get(`window.cpu.sc._isAddin`) as boolean;
  }
  public async getRoomUrl(): Promise<string> {
    return await this.parent.get(`window.cpu.sc._url`) as string;
  }
  public async getPodTitle(): Promise<string> {
    return await this.parent.get(`window.cpu.sc._podTitle`) as string;
  }
  public async getRoomSCOID(): Promise<string> {
    return await this.parent.get(`window.cpu.sc._roomSCOID`) as string;
  }
}

